import { render, staticRenderFns } from "./editAcceptStudentModal.vue?vue&type=template&id=14e564a5&"
import script from "./editAcceptStudentModal.vue?vue&type=script&lang=js&"
export * from "./editAcceptStudentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports